/* EmojiPickerFooter.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./EmojiPickerFooter.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { memo } from 'react';
import { N30A } from '@atlaskit/theme/colors';
import { EmojiPreviewComponent } from '../common/EmojiPreviewComponent';
var emojiPickerFooter = null;
var emojiPickerFooterWithTopShadow = null;
export var emojiPickerFooterTestId = 'emoji-picker-footer';
var EmojiPickerFooter = function EmojiPickerFooter(_ref) {
  var selectedEmoji = _ref.selectedEmoji;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": emojiPickerFooterTestId,
    className: ax(["_16jlidpf _1o9zidpf _i0dl1wug", "_x3do18ew _16qs4j53"]),
    style: {
      "--_m6cf7x": ix("2px solid ".concat("var(--ds-border, ".concat(N30A, ")"))),
      "--_cfawkn": ix("0px -1px 1px 0px ".concat("var(--ds-border, rgba(0, 0, 0, 0.1))"))
    }
  }, selectedEmoji && /*#__PURE__*/React.createElement(EmojiPreviewComponent, {
    emoji: selectedEmoji
  }));
};
export default /*#__PURE__*/memo(EmojiPickerFooter);